import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import Button from '../../components/ui/Button';
import api from '../../services/api';

const statusLabel = { pending: 'Ожидает', in_progress: 'В работе', completed: 'Завершено' };

export default function TaskList() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/tasks?page=1&per_page=100');
        if (res?.data) setTasks(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const columns = [
    { key: 'title', label: 'Задача', render: v => <span style={{ fontWeight: 600, fontSize: 13 }}>{v}</span> },
    { key: 'type', label: 'Тип', render: v => <Badge variant={v === 'osg' ? 'osg' : v === 'display' ? 'display' : 'gray'}>{v === 'osg' ? 'ОСГ' : v === 'display' ? 'Выкладка' : v || '\u2014'}</Badge> },
    { key: 'priority', label: 'Приоритет', render: v => <Badge variant={v === 'urgent' ? 'urgent' : 'normal'}>{v === 'urgent' ? 'Срочный' : 'Обычный'}</Badge> },
    { key: 'status', label: 'Статус', render: v => <Badge variant={v} dot>{statusLabel[v] || v || '\u2014'}</Badge> },
    { key: 'assigned_to_name', label: 'Исполнитель', render: v => v || '\u2014' },
    { key: 'due_date', label: 'Срок', render: v => v ? new Date(v).toLocaleDateString('ru-RU') : '\u2014' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Задачи</h1>
        <Button icon={<Plus size={15} />} onClick={() => navigate('/tasks/create')}>Создать</Button>
      </div>
      <Card padding="0">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={tasks} emptyText="Нет задач. Данные поступают из системы." />
        )}
      </Card>
    </div>
  );
}
